export default function buildAuthorizeUrl({authorize_url, client_id, callback_url}) {
  return `${authorize_url}?client_id=${client_id}&response_type=code&scope=aws.cognito.signin.user.admin email openid phone profile&redirect_uri=${callback_url}`
}
